import React from 'react';

export default class Page4 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">

                                <div className="ilead-rgt task">
                                    <div className="innerpadding">


                                        <div className="ilead-contentarea">

                                            <table width="100%" border="0" cellSpacing="0" cellPadding="0"
                                                   className="ilead_v_sport tablesrink people_active">
                                                <tbody>
                                                <tr>
                                                    <td className="darkgreen" align="left" valign="top"
                                                        width="100%">
                                                        <span className="table_inner_cont">4</span><p
                                                        className="table_inner_cont_p"
                                                        style={{paddingBottom:'5px !important'}}>
                                                        Ms. L, a 30–year-old research physicist, has been given
                                                        a five-year appointment by a major university
                                                        laboratory. As she contemplates the next five years, she
                                                        realises that she might be given the
                                                        opportunity to work on a difficult, long-term scientific
                                                        problem, a solution for which would win
                                                        accolades for her. If no solution were found, however,
                                                        Ms. L would have little to show for her five years
                                                        in the laboratory and would find it difficult to get a
                                                        good job afterwards. On the other hand, she could,
                                                        as most of her professional associates are doing, work
                                                        on a series of short-term problems for which
                                                        solutions are easier to find but of less scientific
                                                        importance. Tick the lowest probability you‘d consider
                                                        acceptable to make it worthwhile for Ms. L to work on
                                                        the more difficult, long-term problem.
                                                    </p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="100%">

                                                        <input type="checkbox"
                                                               name="MsLA30YearOldResearchPhysicist"
                                                               id="MsLA30YearOldResearchPhysicist1"
                                                               value="1"
                                                               onChange={this.props.handleChangePageData}
                                                               checked={this.props.pageData?.MsLA30YearOldResearchPhysicist === 1}/>
                                                        <label className="cursor-pointer" htmlFor="MsLA30YearOldResearchPhysicist1">&nbsp;</label>

                                                        The chances are 1 in 10 that Ms. L will solve the
                                                        long-term problem.<p className="pad-septar"></p>

                                                        <input type="checkbox"
                                                               name="MsLA30YearOldResearchPhysicist"
                                                               id="MsLA30YearOldResearchPhysicist2"
                                                               value="2"
                                                               onChange={this.props.handleChangePageData}
                                                               checked={this.props.pageData?.MsLA30YearOldResearchPhysicist === 2}/>
                                                        <label className="cursor-pointer" htmlFor="MsLA30YearOldResearchPhysicist2">&nbsp;</label>

                                                        The chances are 3 in 10 that Ms. L will solve
                                                        the long-term problem.<p
                                                        className="pad-septar"></p>

                                                        <input type="checkbox"
                                                               name="MsLA30YearOldResearchPhysicist"
                                                               id="MsLA30YearOldResearchPhysicist3"
                                                               value="3"
                                                               onChange={this.props.handleChangePageData}
                                                               checked={this.props.pageData?.MsLA30YearOldResearchPhysicist === 3}/>
                                                        <label className="cursor-pointer" htmlFor="MsLA30YearOldResearchPhysicist3">&nbsp;</label>

                                                        The chances are 5 in 10 that Ms. L will
                                                        solve the long-term problem.<p
                                                        className="pad-septar"></p>

                                                        <input type="checkbox"
                                                               name="MsLA30YearOldResearchPhysicist"
                                                               id="MsLA30YearOldResearchPhysicist4"
                                                               value="4"
                                                               onChange={this.props.handleChangePageData}
                                                               checked={this.props.pageData?.MsLA30YearOldResearchPhysicist === 4}/>
                                                        <label className="cursor-pointer" htmlFor="MsLA30YearOldResearchPhysicist4">&nbsp;</label>

                                                        The chances are 7 in 10 that Ms. L will
                                                        solve the long-term problem.<p
                                                        className="pad-septar"></p>

                                                        <input type="checkbox"
                                                               name="MsLA30YearOldResearchPhysicist"
                                                               id="MsLA30YearOldResearchPhysicist5"
                                                               value="5"
                                                               onChange={this.props.handleChangePageData}
                                                               checked={this.props.pageData?.MsLA30YearOldResearchPhysicist === 5}/>
                                                        <label className="cursor-pointer" htmlFor="MsLA30YearOldResearchPhysicist5">&nbsp;</label>

                                                        The chances are 9 in 10 that Ms. L
                                                        will solve the long-term problem.<p
                                                        className="pad-septar"></p>

                                                        <input type="checkbox"
                                                               name="MsLA30YearOldResearchPhysicist"
                                                               id="MsLA30YearOldResearchPhysicist6"
                                                               value="6"
                                                               onChange={this.props.handleChangePageData}
                                                               checked={this.props.pageData?.MsLA30YearOldResearchPhysicist === 6}/>
                                                        <label className="cursor-pointer" htmlFor="MsLA30YearOldResearchPhysicist6">&nbsp;</label>

                                                        Tick here if you think Ms. L
                                                        should not choose the long-term,
                                                        difficult problem, no matter
                                                        what the probabilities.<p
                                                        className="pad-septar"></p>


                                                    </td>
                                                </tr>


                                                </tbody>
                                            </table>

                                            <p><span className="subtiltereg">Scoring key:</span> These
                                                situations are taken from a longer questionnaire. Your results
                                                are an indication
                                                of your general orientation toward risk but not a precise
                                                measure. To calculate your risk–taking
                                                score, add up the chances you were willing to take and divide by
                                                4.</p>
                                            <p>Use the chance rating that you gave, so for example a 7 in 10
                                                chance should be calculated as 7.</p>
                                            <p>For any of the situations in which you would not take a risk
                                                regardless of the probabilities, give
                                                yourself a 10.</p>
                                            <p>The lower your number, the more of a risk taker you are.</p>


                                            <div className="lightgreencontentbg keyquestionpad lightbglastp">
                                                <div className="border_subtitle">Implications and
                                                    considerations
                                                </div>
                                                <p><span className="subtiltereg">Score: 1–4:</span> If you take
                                                    risks easily, you‘re likely to be extremely confident or
                                                    optimistic.
                                                    You need to be careful of being either – consider the risk
                                                    to your reputation as well as for
                                                    company resources if, for example, you were to commit funds
                                                    to an unproven product or
                                                    service. Try to analyse the risk and decide if the benefits
                                                    outweigh them regardless of your
                                                    own inclination. Consider how you‘re perceived by others –
                                                    they may consider you reckless
                                                    or a bit of maverick!</p>
                                                <p><span className="subtiltereg">Score: 5–7:</span> If you take
                                                    calculated risks, you‘ll probably weigh up the pros and cons
                                                    and
                                                    your decision is likely to depend on your own confidence in
                                                    a particular situation. Consider
                                                    gathering additional information or other opinions for when
                                                    you feel less confident, rather
                                                    than relying on your inclinations alone.</p>
                                                <p><span className="subtiltereg">Score: 8–10:</span> If you
                                                    hesitate to take risks or avoid them you‘re probably wary of
                                                    change or
                                                    leaving things to chance. This may be exacerbated after a
                                                    setback of some kind. At work
                                                    you can probably be relied upon to highlight potential risk
                                                    or threats or be cautious and
                                                    pessimistic. Try focusing on the potential benefits and
                                                    opportunities in a situation as well
                                                    as the obstacles. Consider how you may be perceived by your
                                                    colleagues or manager – as
                                                    well as your attitude to change and innovation, generally.
                                                </p>
                                            </div>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page3')}
                                                    className="button-next-previous-done task">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.savePageData('Page5')}
                                                    className="button-next-previous-done task">Next &gt;&gt;</div>
                                            </div>


                                        </div>

                                    </div>


                                </div>


                            </div>
                        </section>

                    </div>
                </div>
            </div>
        </div>;
    }
}